module.exports = __webpack_public_path__ + "./fonts/Arial-Semibold.ttf";